import { Navigate, RouteObject } from "react-router-dom";
import { featureFlags } from "../../featureFlags";
import { withHandle } from "../../utils/route.util";
import { OrdersView } from "./OrdersView";
import { OrdersViewV2 } from "./OrdersViewV2";
import { OrderViewV2 } from "./OrderViewV2";
import { OrderDetailsTab } from "./tabs/OrderDetailsTab";
import { OrderItemsTab } from "./tabs/OrderItemsTab";
import { OrderEventLogsTab } from "./tabs/OrderEventLogsTab";
import { OrderShipmentsTab } from "./tabs/OrderShipmentsTab";
import { OrderView } from "./OrderView";
import { OrderItemView } from "./OrderItemView";

const orderDetailTabs: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="details" replace />,
    ...withHandle("order-details"),
  },
  {
    path: "details",
    element: <OrderDetailsTab />,
    ...withHandle("order-details"),
  },
  {
    path: "items",
    element: <OrderItemsTab />,
    ...withHandle("order-items"),
  },
  {
    path: "event-logs",
    element: <OrderEventLogsTab />,
    ...withHandle("order-event-logs"),
  },
  {
    path: "shipments",
    element: <OrderShipmentsTab />,
    ...withHandle("order-shipments"),
  },
  {
    path: "*",
    element: <Navigate to="details" replace />,
    ...withHandle("order-details"),
  },
];

export const ordersRoutes: RouteObject[] = featureFlags.newOrderManagement
  ? [
      {
        path: "orders",
        element: <OrdersViewV2 />,
        ...withHandle("orders"),
      },
      {
        path: "orders/:customerPublicId/:customerOrderId",
        element: <OrderViewV2 />,
        ...withHandle("order-detail", { navigateOnSandboxToggle: "/dashboard/orders" }),
        children: orderDetailTabs,
      },
    ]
  : [
      {
        path: "orders",
        element: <OrdersView />,
        ...withHandle("orders"),
      },
      {
        path: "orders/:customerPublicId/:customerOrderId",
        element: <OrderView />,
        ...withHandle("order-detail", { navigateOnSandboxToggle: "/dashboard/orders" }),
      },
      {
        path: "orders/:customerPublicId/:customerOrderId/items/:itemId",
        element: <OrderItemView />,
        ...withHandle("order-item"),
      },
    ];
